import React from 'react';

const PageHeader = ({ pageTitle }) => {
    return (
        <header className=''>
            <div className='pb-8'><h1 className='text-3xl font-bold'>{pageTitle}</h1></div>

        </header>
    );
};

export default PageHeader